import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faInfoCircle, faStopCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'dialog-confirmacion',
    templateUrl: 'dialogConfirmacion.html',
    styleUrls: [/* '../../../theme/styles/_common.scss', */'dialogConfirmacion.component.scss'],
    encapsulation: ViewEncapsulation.None
  })
  
  export class DialogConfirmacion {
    titulo: string;
    mensaje: string;
    //confirm: boolean;
    opciones: any = {
      textarea1: {
        visible: false,
        title: null,
        value: null
      },
      checkbox1: {
        visible: false, 
        title: null,
        value: null
      }
    };
    tipo : any;
    colorTheme = ""
    colorIconClass = ""
    public icons : any = { error : faStopCircle, info : faInfoCircle, };
    constructor(
      public dialogRef: MatDialogRef<DialogConfirmacion>,
      @Inject(MAT_DIALOG_DATA) public data: any
      ) {          
          this.titulo = this.data.titulo;
          this.mensaje = this.data.mensaje; 
          this.opciones.textarea1 = this.data.opciones ? this.data.opciones.textarea1 : {}; 
          this.opciones.checkbox1 = this.data.opciones ? this.data.opciones.checkbox1 : {};
          this.tipo = data.tipo ;
          this.ChangeTheme();
          this.ColorIcon();
      }
  
    ngOnInit(){
      
    }
    ChangeTheme(){
      switch (this.tipo) {
        case 1:
            this.colorTheme = "error";
          break;
        case 2:
            this.colorTheme = "info";
          break;
        case 3:
            this.colorTheme = "success";
          break;
        case 4:
        case 5:
            this.colorTheme = "warning";
          break;
      }
    }
    ColorIcon(){
      this.colorIconClass= "mat-icon-"
      switch (this.tipo) {
        case 1:
          this.colorIconClass += "error";
          break;
        case 2:
          this.colorIconClass += "info";
          break;
        case 3:
          this.colorIconClass += "success";
          break;
        case 4:
        case 5:
          this.colorIconClass += "warning";
          break;
      }
    }

    onOkClick(): void {
      this.data.confirm = true;
      this.dialogRef.close(this.data);
    }

    onNoClick(): void {
      this.data.confirm = false;
      this.dialogRef.close(this.data);
    }   
  } 